import React from 'react';
import { X, CheckCheck, Info, AlertTriangle, AlertCircle, CheckCircle } from 'lucide-react';
import { useNotifications } from '../../contexts/NotificationContext';
import { formatDateTime } from '../../utils/helpers';

const NotificationPanel = ({ isOpen, onClose }) => {
  const { notifications, markAsRead, markAllAsRead } = useNotifications();

  const getIcon = (tipo) => {
    switch (tipo) {
      case 'info':
        return <Info className="w-5 h-5 text-blue-500" />;
      case 'warning':
        return <AlertTriangle className="w-5 h-5 text-warning-500" />;
      case 'error':
        return <AlertCircle className="w-5 h-5 text-danger-500" />;
      case 'success':
        return <CheckCircle className="w-5 h-5 text-success-500" />;
      default:
        return <Info className="w-5 h-5 text-gray-500" />;
    }
  };

  if (!isOpen) return null;

  return (
    <>
      <div
        className="fixed inset-0 bg-black bg-opacity-30 z-40"
        onClick={onClose}
      ></div>

      <div className="fixed right-0 top-0 h-full w-full max-w-md bg-white shadow-strong z-50">
        <div className="flex flex-col h-full">
          <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200">
            <div>
              <h2 className="text-xl font-semibold text-gray-900">Notificaciones</h2>
              <p className="text-sm text-gray-500 mt-1">
                {notifications.filter(n => !n.leida).length} sin leer
              </p>
            </div>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600 transition-colors"
            >
              <X className="w-6 h-6" />
            </button>
          </div>

          {notifications.filter(n => !n.leida).length > 0 && (
            <div className="px-6 py-3 border-b border-gray-200">
              <button
                onClick={markAllAsRead}
                className="flex items-center text-sm text-primary-600 hover:text-primary-700 font-medium"
              >
                <CheckCheck className="w-4 h-4 mr-2" />
                Marcar todas como leídas
              </button>
            </div>
          )}

          <div className="flex-1 overflow-y-auto">
            {notifications.length === 0 ? (
              <div className="flex flex-col items-center justify-center h-full text-gray-500">
                <Info className="w-12 h-12 mb-3 text-gray-300" />
                <p>No hay notificaciones</p>
              </div>
            ) : (
              <div className="divide-y divide-gray-200">
                {notifications.map((notification) => (
                  <div
                    key={notification.id}
                    className={`px-6 py-4 hover:bg-gray-50 transition-colors cursor-pointer ${
                      !notification.leida ? 'bg-blue-50' : ''
                    }`}
                    onClick={() => !notification.leida && markAsRead(notification.id)}
                  >
                    <div className="flex items-start space-x-3">
                      <div className="flex-shrink-0 mt-1">
                        {getIcon(notification.tipo)}
                      </div>
                      <div className="flex-1 min-w-0">
                        <p className="text-sm font-medium text-gray-900">
                          {notification.titulo}
                        </p>
                        <p className="text-sm text-gray-600 mt-1">
                          {notification.mensaje}
                        </p>
                        <p className="text-xs text-gray-500 mt-2">
                          {formatDateTime(notification.timestamp)}
                        </p>
                      </div>
                      {!notification.leida && (
                        <div className="flex-shrink-0">
                          <div className="w-2 h-2 bg-primary-600 rounded-full"></div>
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default NotificationPanel;
